module.exports = __webpack_public_path__ + "static/img/doctor.default.ca1f277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor.default.png
// module id = 404
// module chunks = 382